export const PORTUGUESE_MONTHS_LABELS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
]

export const GRAPH_COLORS = [
  '#1abc9c',
  '#FD7272',
  '#54a0ff',
  '#f39c12',
  '#2c3e50',
  '#fd79a8',
  '#2980b9',
  '#a29bfe',
  '#16a085',
  '#d35400',
  '#25CCF7',
  '#00d2d3',
  '#2ecc71',
  '#3498db',
  '#9b59b6',
  '#34495e',
  '#27ae60',
  '#8e44ad',
  '#f1c40f',
  '#e67e22',
  '#e74c3c',
  '#ecf0f1',
  '#95a5a6',
  '#c0392b',
  '#bdc3c7',
  '#7f8c8d',
  '#55efc4',
  '#81ecec',
  '#74b9ff',
  '#dfe6e9',
  '#00b894',
  '#00cec9',
  '#0984e3',
  '#6c5ce7',
  '#ffeaa7',
  '#fab1a0',
  '#ff7675',
  '#fdcb6e',
  '#e17055',
  '#d63031',
  '#feca57',
  '#5f27cd',
  '#54a0ff',
  '#01a3a4',
]
